export const DOCUMENTS_PAGE = {
  title: "Documents publics",
  eyebrow: "Consultation en ligne",
  description:
    "Retrouvez les comptes-rendus, arrêtés, formulaires, publications et documents publics mis à disposition par la mairie.",
  heroImageUrl:
    "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Ma Ville" },
    { label: "Documents" },
  ],
};

export const DOCUMENT_LIMIT_OPTIONS = [6, 9, 12, 18, 24];

export const DOCUMENT_SORT_OPTIONS = [
  { value: "created_at", label: "Date de publication" },
  { value: "title", label: "Titre" },
  { value: "category", label: "Catégorie" },
];

export const DOCUMENT_DIR_OPTIONS = [
  { value: "DESC", label: "Plus récents d’abord" },
  { value: "ASC", label: "Plus anciens d’abord" },
];